import { rgbToCmyk, rgbToCss, rgbToHsl, rgbToHsv, rgbToXyz, xyzToCIELab } from ".";
import { InvalidColorError, isValidHex } from "../validators";
const validator = (hex, converter) => {
    if (!isValidHex(hex))
        throw new InvalidColorError(hex, "HEX");
    return converter;
};
const toRgb = (hex) => {
    return {
        r: parseInt(hex.substring(0, 2), 16),
        g: parseInt(hex.substring(2, 4), 16),
        b: parseInt(hex.substring(4, 6), 16)
    };
};
export const hexToRgb = (hex) => validator(hex, toRgb)(hex);
export const hexToCss = (hex, options) => validator(hex, rgbToCss)(toRgb(hex), options);
export const hexToHsl = (hex, options) => validator(hex, rgbToHsl)(toRgb(hex), options);
export const hexToHsv = (hex, options) => validator(hex, rgbToHsv)(toRgb(hex), options);
export const hexToCmyk = (hex) => validator(hex, rgbToCmyk)(toRgb(hex));
export const hexToXyz = (hex, options) => validator(hex, rgbToXyz)(toRgb(hex), options);
export const hexToCIELab = (hex, options) => validator(hex, xyzToCIELab)(hexToXyz(hex, options), options);
